/* Preserve the two approved compositions and let edited copy expand the layout. */
(() => {
 const desktopContent = section => matchMedia('(min-width:1024px)').matches && document.body.classList.contains('scenthouse-template') && section.closest('#MainContent') && section.id !== 'scenthouse-footer';
 const mobileCopy=new WeakMap();
 const fvMobileImage=new WeakMap();
 const visitBreaks={"LBx8y3NwpJhByqBm":"那古野の街で、\n香りに出会う一日を。","LB5WQQBt3NDMDK7M":"ひとりでじっくり。大切な人と一緒に。\n街歩きの途中にも、香りを選ぶひとときを。","LBqXPNlsh2H2M38h":"〒451-0042\n愛知県名古屋市西区那古野1丁目18番2号","LBS9V8ZQHRSP8ZPY":"国際センター駅から徒歩約5分\n名古屋駅から徒歩約15分"};
 const active = section => section.querySelector(matchMedia('(max-width:1023px)').matches || desktopContent(section) ? '.sh-layout-sp' : '.sh-layout-pc');
 function layout(section) {
  const frame=active(section), stage=frame?.querySelector('.sh-stage');
  if(!stage)return;
  // 画面幅が1366px(デザイン原寸)より広いと、そのまま引き伸ばして
  // 100%超に拡大してしまい他ページより大きく見えていたため、
  // 等倍(1)を上限にする（それより狭い画面では従来通り縮小表示）。
  const desktop=desktopContent(section);
  const scale=desktop ? 0.44 : Math.min(section.clientWidth/1366, 1);

  // Desktop FV follows the existing PC image setting; mobile keeps its own image.
  if(section.id==='scenthouse-intro' && frame.classList.contains('sh-layout-sp')){
   const image=stage.querySelector('.sh-image img'), pcImage=section.querySelector('.sh-layout-pc [data-sh-fv] img');
   if(image){
    const attrs=['src','srcset','sizes','width','height','alt','class','loading'];
    if(!fvMobileImage.has(image))fvMobileImage.set(image,Object.fromEntries(attrs.map(a=>[a,image.getAttribute(a)])));
    const original=fvMobileImage.get(image);
    for(const a of attrs){
     const value=desktop && pcImage ? (a==='class' ? 'sh-custom' : a==='loading' ? 'eager' : pcImage.getAttribute(a)) : original[a];
     if(value===null)image.removeAttribute(a);else if(image.getAttribute(a)!==value)image.setAttribute(a,value);
    }
   }
  }
  const nodes=[...stage.querySelectorAll(':scope > .sh-node')];
  const growth=[];
  for(const node of nodes){
   // PC Canva specifies these line breaks; retain exact mobile copy for resizing back.
   if(section.id==='scenthouse-visit' && frame.classList.contains('sh-layout-sp')){
    const key=Object.keys(visitBreaks).find(k=>node.classList.contains('sh-visit-sp-'+k));
    if(key) for(const p of node.querySelectorAll('.sh-paragraph')){
     if(!mobileCopy.has(p))mobileCopy.set(p,p.textContent);
     const original=mobileCopy.get(p), wanted=visitBreaks[key];
     p.textContent=desktop && original.replace(/\s/g,'')===wanted.replace(/\s/g,'') ? wanted : original;
    }
   }
   // Restore untouched mobile geometry when resizing down from desktop.
   if(!desktop && section.id==='scenthouse-intro' && frame.classList.contains('sh-layout-sp') && node===nodes[0]){node.style.removeProperty('left');node.style.removeProperty('width');}
   node.style.top=node.dataset.baseY+'px';
   node.style.height=node.dataset.baseH+'px';
   if(node.matches('.sh-text') && (node.dataset.edited==='true' || matchMedia('(max-width:1023px)').matches)){
    const paragraphs=node.dataset.edited==='true' ? [node.querySelector('.sh-edit')] : [...node.querySelectorAll('.sh-original .sh-paragraph')];
    const actual=Math.max(0,...paragraphs.filter(Boolean).map(text=>text.offsetHeight+Math.max(0,parseFloat(text.style.top)||0)));
    const extra=Math.max(0,actual-Number(node.dataset.baseH));
    if(extra>0.5){node.style.height=actual+'px';growth.push({bottom:Number(node.dataset.baseY)+Number(node.dataset.baseH),extra});}
   }
   // FV（最初のメイン画像）は、拡大縮小後の見た目の縦横幅が画面
   // ぴったりになるよう調整する。縦方向は他の要素と同じ「はみ出し分だけ
   // 下を押し下げる」仕組みに乗せ、横方向はステージ全体の拡大率とは別に、
   // このノードだけ画面幅ぴったりになる幅・左位置を計算して上書きする
   // （元の座標データは一切書き換えず、表示時にだけ計算している）。
   if(node.matches('[data-sh-fv]') || (desktop && section.id==='scenthouse-intro' && node===nodes[0] && node.matches('.sh-image'))){
    const viewportH=window.visualViewport?window.visualViewport.height:window.innerHeight;
    const targetH=viewportH/scale;
    if(desktop){node.style.left=(683-section.clientWidth/scale/2)+'px';node.style.width=(section.clientWidth/scale)+'px';}
    const base=Number(node.dataset.baseH);
    const extra=targetH-base;
    if(Math.abs(extra)>0.5){node.style.height=targetH+'px';growth.push({bottom:Number(node.dataset.baseY)+base,extra});}
    const centerX=desktop ? 683 : Number(node.dataset.centerX);
    if(!Number.isNaN(centerX)){
     const targetW=section.clientWidth/scale;
     node.style.width=targetW+'px';
     node.style.left=(centerX-targetW/2)+'px';
    }
   }
  }
  // Overlapping columns share the largest expansion rather than adding it twice.
  const bands=[];
  for(const item of growth.sort((a,b)=>a.bottom-b.bottom)){
   const prev=bands[bands.length-1];
   if(prev&&Math.abs(prev.bottom-item.bottom)<8)prev.extra=Math.max(prev.extra,item.extra);
   else bands.push({...item});
  }
  for(const node of nodes){
   const y=Number(node.dataset.baseY);
   const extra=bands.filter(g=>g.bottom<=y+1).reduce((n,g)=>n+g.extra,0);
   node.style.top=(y+extra)+'px';
  }
  const height=Number(stage.dataset.designHeight)+bands.reduce((n,g)=>n+g.extra,0);
  stage.style.height=height+'px';stage.style.transform='scale('+scale+')';
  frame.style.height=(height*scale)+'px';
 }
 let scheduled=false;
 function update(){if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{document.querySelectorAll('[data-sh-section]').forEach(layout);scheduled=false;});}
 const observer=new ResizeObserver(update);
 function init(){document.querySelectorAll('[data-sh-section]').forEach(s=>observer.observe(s));update();}
 init();addEventListener('resize',update);document.fonts.ready.then(update);
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('shopify:block:select',e=>{e.target.scrollIntoView({block:'center',behavior:'auto'});});
 document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('[data-sh-section]').forEach(s=>observer.unobserve(s));});
})();
